export default __webpack_public_path__ + "static/media/hero.38cc610f.png";